import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { IMenuEventParams } from '@src/slide/application/service/menu-manager/menu-event/menu-event.interface';
import { IConnectorModel } from '@src/slide/domain/ui-model/element-modeles/Interface/connector-model.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import * as mobx from 'mobx';
import { transaction } from '@src/slide/domain/slide-app';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import * as connectorEvent from '@src/slide/application/service/menu-manager/menu-event/model/connector';
import * as pictureEvent from '@src/slide/application/service/menu-manager/menu-event/model/picture';
import * as shapeEvent from '@src/slide/application/service/menu-manager/menu-event/model/shape';
import { IGroupModel } from '@src/slide/domain/ui-model/element-modeles/Interface/group-model.interface';
import _cloneDeep from 'lodash/cloneDeep';

/**
 * 批量处理事件
 * @param models uiModel数组
 * @param menuEventParams 菜单传参
 */
export function batchedHandleMenuEvent(models: IBaseModel[], menuEventParams: IMenuEventParams) {
    const newMenuEventParams = {
        ...menuEventParams,
        extraOption: {
            ...menuEventParams.extraOption,
            isMultiGroup: true,
        },
    };
    let hasExecuted = false;
    mobx.transaction(() => {
        transaction(() => {
            models.forEach((model) => {
                const cloneParams = { ...newMenuEventParams };
                if (cloneParams.values) {
                    cloneParams.values = _cloneDeep(cloneParams.values);
                }
                // 连接线
                if (UIModelType.CONNECTOR === model.type) {
                    hasExecuted = connectorEvent.handleMenuEvent(model as IConnectorModel, cloneParams)
                        || hasExecuted;
                }
                // 图片
                if (UIModelType.IMAGE === model.type) {
                    hasExecuted = pictureEvent.handleMenuEvent(model as IPictureModel, cloneParams)
                        || hasExecuted;
                }
                // 形状
                if (UIModelType.SHAPE === model.type) {
                    hasExecuted = shapeEvent.handleMenuEvent(model as IShapeModel, cloneParams)
                        || hasExecuted;
                }
                // 组合
                if (UIModelType.GROUP === model.type) {
                    hasExecuted = batchedHandleMenuEvent((model as IGroupModel).children, menuEventParams)
                        || hasExecuted;
                }
            });
        });
    });
    return hasExecuted;
}
